import styled from 'styled-components'
import { breakpoints } from '../../../constants'

export const StyledCardInfo = styled.div`
	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		display: flex;
	}

	& > * {
		@media screen and (min-width: ${breakpoints.MOBILE}px) {
			flex: 1;
		}
	}

	.card-number {
		& > :last-child {
			display: flex;
			align-items: center;

			.card-logo {
				max-width: 50px;
				margin-right: 15px;
			}
		}
	}
`
